import * as React from 'react';
import { Alert } from 'react-bootstrap';

import './DocUploadHeader.css';
import { DocUploadMap, DocUploadSteps } from '../../common/models';

interface DocUploadHeaderProps {
  docUploadMap: DocUploadMap;
}

export const DocUploadHeader = ({ docUploadMap}: DocUploadHeaderProps) => {
  const all = docUploadMap.flatten();
  const total = all.length;
  const remaining = all
    .filter(docUpload => docUpload.step.code !== DocUploadSteps.DONE.code && !docUpload.error).length;
  const failed = all.filter(docUpload => !!docUpload.error).length;
  const done = docUploadMap.byStep(DocUploadSteps.DONE).length;

  return (
    <div className="DocUploadHeader">
      <ul className="list-inline">
        {remaining > 0 &&
          <li>
            <h2>{remaining} remaining</h2>
          </li>
        }
        {failed > 0 &&
          <li>
            <h2 className="text-danger">{failed}/{total} Failed</h2>
          </li>
        }
        {done > 0 &&
          <li>
            <h2 className="text-success">{done}/{total} Done</h2>
          </li>
        }
      </ul>
      {remaining > 0 &&
        <Alert bsStyle="warning">
          <strong>Do not leave this page until uploads have finished.</strong>
        </Alert>
      }
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/DocUploaderView/DocUploadHeader/DocUploadHeader.tsx